import { colors } from "../../Styles";

export function Setting({ size = "20px", fillColor = colors.greyLightTertiary, animation = false }) {


  
  return (
    <svg className={animation ? "spin" : undefined} height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <style>
        {`
          .spin {
            animation: spin 10s linear infinite;
            transform-origin: center;
          }

          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <path d="M274.08,164.33v-45.19l-26.86-3.24c-1.36-4.82-5.44-17.85-12.38-28.6l15.65-21.63-31.51-32.02-22.08,17.02c-4.3-2.91-15.76-10.1-27.34-12.5l-4.6-27.57h-46.45l-4.6,27.57c-11.59,2.4-23.05,9.59-27.34,12.5l-22.08-17.02-31.51,32.02,15.65,21.63c-6.93,10.75-11.01,23.78-12.38,28.6l-26.86,3.24v45.19l26.86,3.24c1.36,4.82,5.44,17.85,12.38,28.6l-15.65,21.63,31.51,32.02,22.08-17.02c4.3,2.91,15.76,10.1,27.34,12.5l4.6,27.57h46.45l4.6-27.57c11.59-2.4,23.05-9.59,27.34-12.5l22.08,17.02,31.51-32.02-15.65-21.63c6.93-10.75,11.01-23.78,12.38-28.6l26.86-3.24ZM219.93,141.73c0,42.76-35.08,77.55-78.2,77.55s-78.2-34.79-78.2-77.55,35.08-77.55,78.2-77.55,78.2,34.79,78.2,77.55Z" />
    </svg>
  );
}
